import { Pipe, PipeTransform } from '@angular/core';

/**
 * * Pipe para ordenação por propriedade.
 */
@Pipe({
  name: 'orderBy'
})
export class OrderByPipe implements PipeTransform {

  transform<T extends {[key: string]: any}>(value: T[], ...args: string[]): T[] {
    return value.sort((a, b) => {
      const aValue = a[args[0]];
      const bValue = b[args[0]];
      return (aValue > bValue) ? 1 : ((bValue > aValue) ? -1 : 0);
    });
  }

}
